function I(r, l, x) {
  var t = r.length, u = l.length, f, e;
  if (t === 0 && u === 0)
    return null;
  t < u ? (f = r, e = l) : (f = l, e = r);
  var _ = {
    __EMPTY_ITEM__: !0
  };
  function a(o) {
    return o !== void 0 ? x(o) : _;
  }
  for (var v = null, d = Math.abs(t - u) !== 1, n = 0; n < e.length; n += 1) {
    var i = a(f[n]), h = a(e[n]);
    if (i !== h) {
      v = n, d = d || i !== a(e[n + 1]);
      break;
    }
  }
  return v === null ? null : {
    index: v,
    multiple: d
  };
}
export {
  I as findListDiffIndex
};
//# sourceMappingURL=algorithmUtil.mjs.map
